import { ANONYMOUS_CUSTOMER_ID } from '~/constants';
import type { AppConfiguration } from '~/models';
import type { GetUrlOptions } from '~/utils';

interface UrlOptionsParams<T> {
  configuration: AppConfiguration;
  basePath: string;
  queryParams?: T;
  host?: string;
}

export const getUrlOptions = <T extends object>({
  configuration,
  basePath,
  queryParams,
  host,
}: UrlOptionsParams<T>) => {
  const { currentLanguage, customerId, identityUrl, tenant } = configuration;
  const isCustomerAnonymous = customerId === ANONYMOUS_CUSTOMER_ID;
  let query: string | undefined;
  if (queryParams) {
    const params = new URLSearchParams();
    Object.entries(queryParams).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        params.append(key, String(value));
      }
    });
    query = `?${params.toString()}`;
  }
  const usedHost = host ?? window.location.origin;
  const urlOptions: GetUrlOptions = {
    basePath,
    currentLanguage,
    host: usedHost,
    identityUrl,
    isCustomerAnonymous,
    query,
    tenant,
  };
  const cacheKeys = Object.values(urlOptions);

  return { cacheKeys, urlOptions };
};
